import { ContentDto, TranslationDto } from 'models/dtoTypes';

interface Translations {
  [stringId: string]: string;
}

interface Resource {
  code: string;
  namespace: string;
  translations: Translations;
}

function generateTranslations(list: TranslationDto[]): Translations {
  return Object.assign({}, ...list.map((p) => ({ [p.stringId]: p.text }))) as Translations;
}
function generateResources(list: ContentDto[]): Resource[] {
  return list.map((c) => ({
    code: c.locale.code,
    namespace: c.namespace || 'default',
    translations: generateTranslations(c.translations),
  }));
}

export default generateResources;
